import { render, staticRenderFns } from "./DesignerEditor.vue?vue&type=template&id=6c2deb54&scoped=true"
import script from "./DesignerEditor.vue?vue&type=script&lang=ts"
export * from "./DesignerEditor.vue?vue&type=script&lang=ts"
import style0 from "./DesignerEditor.vue?vue&type=style&index=0&id=6c2deb54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2deb54",
  null
  
)

export default component.exports